import { render, staticRenderFns } from "./img.vue?vue&type=template&id=1731a2b2&scoped=true"
import script from "./img.vue?vue&type=script&lang=js"
export * from "./img.vue?vue&type=script&lang=js"
import style0 from "./img.vue?vue&type=style&index=0&id=1731a2b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1731a2b2",
  null
  
)

export default component.exports